import React, { useEffect, useState } from 'react';
import { Modal, Form, Badge } from 'react-bootstrap';
import ClinicalButton, { ClinicalModalActions } from '../../doctor/ui/ClinicalButton';
import { NURSE_COPY } from '../nurseCopy';

const W = NURSE_COPY.WORKSPACE;

export default function NurseCloseVisitModal({
  show,
  onHide,
  loading,
  onConfirm,
  consultation
}) {
  const [closureNote, setClosureNote] = useState('');

  const diseases = Array.isArray(consultation?.diseases) ? consultation.diseases : [];
  const hasCodedDiagnosis = diseases.length > 0 || Boolean(consultation?.disease_code?.trim());

  useEffect(() => {
    if (!show || !consultation) return;
    setClosureNote('');
  }, [show, consultation]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm({ closure_note: closureNote.trim() || null });
  };

  return (
    <Modal show={show} onHide={onHide} centered className="nr-workspace-modal">
      <Modal.Header closeButton className="nr-workspace-modal__header">
        <Modal.Title>Clôturer la visite infirmerie</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <ul className="nr-close-checklist small text-muted mb-3">
            <li>{W.CLOSE_CHECK_END}</li>
          </ul>

          {hasCodedDiagnosis ? (
            <div className="mb-3">
              <div className="small fw-semibold text-muted mb-2">{W.CLOSE_DISEASE_LABEL}</div>
              <div className="d-flex flex-wrap gap-1">
                {diseases.length > 0
                  ? diseases.map((d) => (
                      <Badge key={d.id} bg="success" className="font-monospace">
                        {d.code}
                        {d.name ? ` · ${d.name}` : ''}
                      </Badge>
                    ))
                  : (
                    <Badge bg="success" className="font-monospace">
                      {consultation.disease_code}
                    </Badge>
                  )}
              </div>
            </div>
          ) : null}

          <Form.Group>
            <Form.Label>{W.CLOSE_NOTE_LABEL}</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={closureNote}
              onChange={(e) => setClosureNote(e.target.value)}
              disabled={loading}
              placeholder={W.CLOSE_NOTE_PLACEHOLDER}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <ClinicalModalActions>
            <ClinicalButton variant="secondary" onClick={onHide} disabled={loading}>
              Annuler
            </ClinicalButton>
            <ClinicalButton variant="save" type="submit" loading={loading} icon="checkCircle">
              Clôturer la visite
            </ClinicalButton>
          </ClinicalModalActions>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
